import { useSyncExternalStore } from 'react';

/**
 * AI 에이전트 창 — 열림 여부와 폭. 헤더 버튼·도움말·창 자신이 같은 값을 본다.
 * 폭만 브라우저에 기억한다(열림은 새로 들어오면 닫힌 채로 시작 — 대화 서비스를 괜히 부르지 않게).
 */
export interface AiDrawerState { open: boolean; width: number }

export const AI_DRAWER_LIMITS = { minWidth: 320, maxWidth: 800, defaultWidth: 420 };

const KEY = 'openflow.aiDrawer';

function loadWidth(): number {
  try {
    const w = Number(JSON.parse(localStorage.getItem(KEY) || '{}').width);
    if (w >= AI_DRAWER_LIMITS.minWidth && w <= AI_DRAWER_LIMITS.maxWidth) return w;
  } catch { /* 저장소를 못 쓰면 기본값 */ }
  return AI_DRAWER_LIMITS.defaultWidth;
}

let state: AiDrawerState = { open: false, width: loadWidth() };
const listeners = new Set<() => void>();

export function setAiDrawer(patch: Partial<AiDrawerState>) {
  state = { ...state, ...patch };
  if (patch.width !== undefined) {
    try { localStorage.setItem(KEY, JSON.stringify({ width: state.width })); } catch { /* 무시 */ }
  }
  listeners.forEach((l) => l());
}

export function useAiDrawer(): AiDrawerState {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    () => state,
  );
}
